export default "__VITE_ASSET__BvPeN6Qy__"